import { core, toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  data?: core.CommunicationPolicy;
  isInitialized: boolean;
  requestInProgress: boolean;
}

const initialState: State = {
  data: undefined,
  isInitialized: false,
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.TICKETS_COMMUNICATION_POLICY_FETCH_DONE:
    case AppConstants.TICKETS_COMMUNICATION_POLICY_UPDATE_DONE: {
      const policy = toJSON<core.CommunicationPolicy>(payload);
      return {
        ...state,
        data: policy,
        isInitialized: true,
        requestInProgress: false,
      };
    }

    case AppConstants.TICKETS_COMMUNICATION_POLICY_FETCH_FAILED:
    case AppConstants.TICKETS_COMMUNICATION_POLICY_UPDATE_FAILED: {
      return {
        ...state,
        isInitialized: true,
        requestInProgress: false,
      };
    }

    case AppConstants.TICKETS_COMMUNICATION_POLICY_FETCH_STARTING:
    case AppConstants.TICKETS_COMMUNICATION_POLICY_UPDATE_STARTING: {
      return {
        ...state,
        isInitialized: false,
        requestInProgress: true,
      };
    }

    default:
      return state;
  }
}
